import { Component, OnInit } from '@angular/core';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { weightageapprovalModel } from './weightage-approvalmodel';
import { EmpmetricsdisplayComponent } from '../Empmetrics-display/Empmetrics-display.component';
import { ConsecutivereportComponent } from '../Consecutive-report/Consecutive-report.component';
import { customfunctions } from '../common/customfunctions';
declare var $;
@Component({
  selector: 'app-weightage-approval',
  templateUrl: './weightage-approval.component.html',
  styleUrls: ['./weightage-approval.component.css']
})
export class weightageapprovalComponent implements OnInit {

  modelItem = new weightageapprovalModel();
  approvalPendingList: any[] = [];
  filteredList: any[] = [];

  selectedBUHead: string = '';
  selectedBUHeadId: string = '';
    uniqueBUHeads: { BUHeadId: any; BUHeadName: string; }[];
  isDataAvailable: boolean = true;
  selectedEmpForNote: any = null;
  noteText: string = '';
  isMoreInfoFlow: boolean = false;

  showNoteTextarea: boolean = false;
  noteInput: string = '';
  bulkNoteText: string = '';
  isBulkMoreInfoFlow: boolean = false;

  selectedMonthRange: string = '3'; // default value
  showCustomRange: boolean = false;
    aOverAll: any;
    aBUHeadL: any;
    aDepartmentL: any;
    aProductivityR: any;
    aOccupancyR: any;
    aproductivityL: any;
    aOccupancyL: any;
  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <weightageapprovalModel>data["weightageapprovalPage"];

        //$('#buheadFilter').select2({
        //  placeholder: "Select BU Head",
        //  dropdownParent: "#mainFilter"
        //});
        //$('#buheadFilter').val([]).trigger('change');

        this.DashmetricsData();
        //this.getConsecutivereport();
        this.WeightageApprovalPendingListAPI();
        

      },
      error => {
        ngswal("Warning !", error.message, "warning");
      }
    );
  }

  DashmetricsData() {
    $("#LoadingImage").show();
    var FromDate = $('#txtFromDt').val();
    var ToDate = $('#txtFromDt').val();
    if ($('#ddlMonthRange').val()==0) {
      if (!FromDate) {
        ngswal("Warning!", "Please choose a From date!", "warning");
        return;
      }
      if (!ToDate) {
        ngswal("Warning!", "Please choose a To date!", "warning");
        return;
      }
    }

    var Dataitem = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      UserId: 0,
      ManagerId: 0,
      Manager1Id: 0,
      RoleId: localStorage.roleId,
      DepartmentId: 0,
      MonthRange: $('#ddlMonthRange').val(),
      FromDate: $('#txtFromDt').val(),
      ToDate: $('#txtToDt').val()
    };
    ApiMethod.postMethod(this.modelItem.GetWeightageCEODashboardListAPI, Dataitem).subscribe(
      response => {

        
        this.aOverAll = response.aOverAll;
        this.aBUHeadL = response.aBUHeadL;
        this.aDepartmentL = response.aDepartmentL;
        this.aproductivityL = response.aproductivityL;
        this.aOccupancyL = response.aOccupancyL;

        $("#LoadingImage").hide();
      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImage").hide();
      });
  }
  getConsecutivereport() {
    ApiMethod.getMethod(this.modelItem.GetWeightageCEOConsecutivereportAPI).subscribe(
      response => {
        this.aProductivityR = response.aProductivity;
        this.aOccupancyR = response.aOccupancy;
        $("#LoadingImage").hide();
      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImage").hide();
      });
  }



  ngOnInit(): void {
    customfunctions.Set3MonthDateValues("#txtFromDt", "#txtToDt");
  }

  WeightageApprovalPendingListAPI(): void {
    ApiMethod.getMethod(this.modelItem.WeightageApprovalPendingListAPI).subscribe(
      result => {
        const list = result.aitemList || [];
        this.approvalPendingList = list;
        this.filteredList = [...list];
        this.isDataAvailable = list.length > 0;

        if (this.isDataAvailable) {
          this.extractUniqueBUHeads(list);
        }
      },
      error => {
        this.isDataAvailable = false;
        ngswal("Warning !", error, "warning");
      }
    );
  }
 

  extractUniqueBUHeads(list: any[]): void {
    // Create a Map or object to keep unique BUHeads by Id to avoid duplicates
    const buHeadsMap = new Map<number | string, { BUHeadId: any, BUHeadName: string }>();

    list.forEach(emp => {
      if (emp.BUHeadId && emp.BUHeadName && !buHeadsMap.has(emp.BUHeadId)) {
        buHeadsMap.set(emp.BUHeadId, { BUHeadId: emp.BUHeadId, BUHeadName: emp.BUHeadName });
      }
    });

    this.uniqueBUHeads = Array.from(buHeadsMap.values()).sort((a, b) => {
      return a.BUHeadName.localeCompare(b.BUHeadName);
    });
  }
  toggleSelection(emp: any): void {
    emp.selected = !emp.selected;
  }
  onCheckboxChange(emp: any, checked: boolean): void {
    emp.selected = checked;
  }

  applyFilter(): void {
    if (this.selectedBUHeadId) {
      this.filteredList = this.approvalPendingList.filter(emp => emp.BUHeadId == this.selectedBUHeadId);
    } else {
      this.filteredList = [...this.approvalPendingList];
    }
  }

  resetFilter(): void {
    this.selectedBUHeadId = '';
    this.filteredList = [...this.approvalPendingList];
  }

  approve(emp: any, isApproved: boolean): void {
    this.updateApprovalstatus([emp], isApproved);
  }

  moreInfo(emp: any, isApproved: boolean): void {
    this.updateApprovalstatus([emp], isApproved);
  }


  approveAll(isApproved: boolean): void {
    const selectedList = this.filteredList.filter(emp => emp.selected);
    if (selectedList.length === 0) {
      ngswal("Warning !", "No employee selected for approval.", "warning");
      return;
    }
    this.updateApprovalstatus(selectedList, isApproved);
  }

  updateApprovalstatus(selectedList: any[], isApproved: boolean) {
    $("#LoadingImage").hide();
    var Dataitem = {
      Employees: selectedList,
      IsApproved: isApproved,
      ResponceNote: this.bulkNoteText,
      UpdatedBy:localStorage.aLoginID
    };
    ApiMethod.postMethod(this.modelItem.updateApprovalstatusAPI, Dataitem).subscribe(
      response => {

        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }
        this.WeightageApprovalPendingListAPI();
        $("#LoadingImage").hide();

      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImage").hide();
      });
  }


  openNotePopup(emp: any, isMoreInfo: boolean = false) {
    this.selectedEmpForNote = emp;
    this.noteText = emp.ApproverNote || '';
    this.isMoreInfoFlow = isMoreInfo;
  }

  closeNotePopup() {
    this.selectedEmpForNote = null;
    this.noteText = '';
    this.isMoreInfoFlow = false;
  }

  saveNote() {
    if (this.selectedEmpForNote) {
      const note = this.noteText.trim();
      this.selectedEmpForNote.ApproverNote = note;

      this.moreInfo(this.selectedEmpForNote, false);
     
    }
    this.closeNotePopup();
  }


  openBulkNotePopup() {
    const selectedList = this.filteredList.filter(emp => emp.selected);
    if (selectedList.length === 0) {
      ngswal("Warning !", "No employee selected for more info.", "warning");
      return;
    }
    this.isBulkMoreInfoFlow = true;
    this.showNoteTextarea = true;
    this.noteInput = this.bulkNoteText || '';
  }

  toggleNotePopup() {
    this.isBulkMoreInfoFlow = false;
    this.showNoteTextarea = true;
    this.noteInput = this.bulkNoteText || '';
  }

  OverAllsaveNote() {
    this.bulkNoteText = this.noteInput.trim();
    this.showNoteTextarea = false;

    if (this.isBulkMoreInfoFlow) {
      const selectedList = this.filteredList.filter(emp => emp.selected);
      selectedList.forEach(emp => emp.ApproverNote = this.bulkNoteText); // apply note to each
      this.updateApprovalstatus(selectedList, false); // false = Need More Info
    }
  }

  cancelNote() {
    this.showNoteTextarea = false;
    this.noteInput = '';
    this.isBulkMoreInfoFlow = false;
  }



  onMonthRangeChange(): void {
    this.showCustomRange = this.selectedMonthRange === '0';
    customfunctions.Set3MonthDateValues("#txtFromDt", "#txtToDt");
  }

  ResetFilter(): void {
    this.selectedMonthRange = '6'; // Reset to default
    this.showCustomRange = false;
    customfunctions.Set3MonthDateValues("#txtFromDt", "#txtToDt");
  }
}
